import React from 'react';

import './footer.scss';

export default function Footer() {
  return (
    <footer>
      <div className='footer-accent'>
        <span>
          <b>AGENTE INSTITORIO:</b> BANCO PATAGONIA S.A. (CUIT: 30-50000661-3 -
          Domicilio: Av. de Mayo 701 Piso 24 (C1084AAC) C.A.B.A.)
        </span>
      </div>
      <div className='footer-content'>
        <div className='footer-subelement'>Nº DE INSCRIPCIÓN EN SSN076</div>
        <div className='footer-subelement'>
          ATENCIÓN AL ASEGURADO <br />
          <b>0800-666-8400</b>
        </div>
        <div className='footer-subelement'>ORGANISMO DE CONTROL</div>
        <div className='footer-subelement'>
          <b>www.argentina.gob.ar/ssn</b>
        </div>
        <div className='footer-subelement'>
          <div className='ssn-container'>
            <img src={require('../../img/logo-ssn1.png')} alt='' />
          </div>
        </div>
      </div>
      <hr />
      <div className='footer-content'>
        <p className='footer-terms'>
          La compañía de seguros dispone de un Servicio de Atención al Asegurado
          que atenderá las consultas y reclamos que presenten los tomadores de
          seguros, asegurados, beneficiarios y/o derechohabientes.
          <br/>
          <br/>
          El servicio de Atención al Asegurado está integrado por:
          SEGUROS GENERALES RESPONSABLE › Sebastián López Delgado | SUPLENTE › Nadia González Centurión | Teléfono: 0800
          222 7854
          VIDA Y RETIRO RESPONSABLE › Marcelo Forani | SUPLENTE › Luis Argañaraz | Teléfono: 4814-9916.
          <br/>
          <br/> En caso de que el reclamo no haya sido resuelto o que haya sido
          denegada su admisión o desestimado, total o parcialmente, podrá
          comunicarse con la Superintendencia de Seguros de la Nación por
          teléfono al 0800-666-8400, correo electrónico a denuncias@ssn.gob.ar o
          por formulario web.
          <br/>
          <br/> SMG Compañía Argentina de Seguros S.A. | CUIT 30-50003196-0 | Av. Corrientes 1865 PB | (C1045AAA) Buenos
          Aires, Argentina N° de inscripción SSN 0002.
          <br/>
          SMG LIFE Seguros de Vida S.A. | CUIT 30-68584340-0 | Arenales 1826 3° piso | (C1124AAB) Buenos Aires,
          Argentina N° de inscripción SSN 0580.
        </p>
        <div>
          <img
            src={require('../../img/Swiss_Medical_Seguros_Logo.png')}
            alt='Logo SMS'
            style={{height: '40px'}}
          />
        </div>
      </div>
    </footer>
  );
}
